import { StyleSheet } from 'react-native';

import { THEME } from 'reactor/common';

const { COLOR, OFFSET } = THEME;

export default StyleSheet.create({
  container: {
    width: '100%',

    backgroundColor: COLOR.WHITE,
    padding: OFFSET,
    marginBottom: OFFSET,
  },
});
